import { isBrowser } from '@tbitop/ssr';
import { defaultTo, values } from 'lodash-es';
import { AppLogger } from './app-logger';
import { LogLevel } from './log-level';
import { ModuleLogger } from './module-logger';

declare const process: { env: Record<string, string> };

AppLogger.initialize(
  defaultTo(process.env.NX_LOGLEVEL, LogLevel.WARN) as LogLevel,
  process.env.NX_APP_NAME
);

export function getLogger(loggerName: string): ModuleLogger {
  return AppLogger.getModuleLogger(loggerName);
}


type GlobalLoggingApi = {
  setLogLevel(logLevel: LogLevel): void;
};

declare global {
  interface Window {
    tbit: GlobalLoggingApi;
  }
}


if (isBrowser) {
  window.tbit = window.tbit ?? {};
  window.tbit.setLogLevel = (minimumLogLevel: string) => {
    const logLevels = values(LogLevel);
    const logLevel = minimumLogLevel.toUpperCase() as LogLevel;

    if (!logLevels.includes(logLevel)) {
      console.warn(`${logLevel} is not a valid log level. Valid log levels are ${logLevels.join(', ')}`);
      return;
    }

    AppLogger.setLogLevel(logLevel);
  };
}
